const state = () => ({
  popups: {
    Video: false,
    Image: false,
  },
  videoModalEmbed: '',
  imageModalUrl: '',
})

const mutations = {
  togglePopups (state, popup) {
    state.popups[popup] = !state.popups[popup]
  },
  setLargeBackdrop (state, status) {
    state.largeBackdrop = status
  },
  setPopup (state, popup, status) {
    state.popups[popup] = status
  },
  setVideoModalEmbed (state, url) {
    state.videoModalEmbed = url
  },
  setImageModalUrl (state, url) {
    state.imageModalUrl = url
  },
  closeAllPopups (state) {
    Object.entries(state.popups).forEach(([key, value]) => state.popups[key] = false);
    state.largeBackdrop = false
  }
}

const getters = {
  hasShowPopups: state => {
    return Object.values(state.popups).includes(true);
  },
  hasVisiblePopup: state => key => {
    return state.popups[key]
  },
  getVideoModalEmbed: state => {
    return state.videoModalEmbed
  },
  getImageModalUrl: state => {
    return state.imageModalUrl
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
